import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { ApplicationService } from '../../../../services/application.service.js';
import { style } from './employment-active-toggle.style.js';
import { globalStyle } from '../../../../global-styles.style.js';
import { REFI_PERSONAL_CONST } from '../../../../shared/constants/app.constants.js';
import { stratum } from '../../../../../constants/stratum.js';

class RefiPersonalEmploymentActiveToggleComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepEmploymentActiveToggle');
    this.applicant = {};
    this.active = false;
    this.employmentActiveMissing = true;
    this.isIconic = false;
  }

  static styles = [style, globalStyle];

  static properties = {
    applicant: { type: Object, reflect: true },
    isPrimary: { type: Boolean, attribute: 'is-primary', reflect: true },
    employmentActiveMissing: { type: Boolean, reflect: true },
    isIconic: { type: Boolean, attribute: 'is-iconic', reflect: true },
  };

  connectedCallback() {
    super.connectedCallback();
    this.application = ApplicationService.Application;
    this.applicant = this.isPrimary
      ? this.application.primaryApplicant
      : this.application.coApplicant;
    this.coAppPrefix = this.isPrimary ? '' : 'co-';
    this.values = {
      activeIncomeVerification:
        this.applicant.employmentInfo.activeIncomeVerification,
    };
    this.employmentActiveMissing =
      this.values.activeIncomeVerification === '' ||
      this.values.activeIncomeVerification === null;
  }

  render() {
    return html`
      <div role="radiogroup" aria-labelledby="toggleEmploymentActiveHeader">
        ${this.isIconic
          ? html`<fs-heading
              level="2"
              size="small"
              variant="primary"
              id="toggleEmploymentActiveHeader"
            >
              Are you actively generating income from this employment?
            </fs-heading>`
          : html` <fs-body-text size="normal" id="toggleEmploymentActiveHeader">
              Are you actively generating income from this employment?
            </fs-body-text>`}

        <div>
          <fs-radio
            id="toggleEmploymentActiveYes"
            name="toggleEmploymentActive"
            value="${REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.yes}"
            required
            ?checked="${this.values.activeIncomeVerification ===
            REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.yes}"
            @change="${this.employmentActiveChange}"
            >Yes
          </fs-radio>
        </div>
        <div>
          <fs-radio
            id="toggleEmploymentActiveNo"
            name="toggleEmploymentActive"
            value="${REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.no}"
            required
            ?checked="${this.values.activeIncomeVerification ===
            REFI_PERSONAL_CONST.ACTIVE_INCOME_VERIFICATION_TYPE.no}"
            @change="${this.employmentActiveChange}"
            >No, this employment is on hold right now or has recently ended
          </fs-radio>
        </div>
        <fs-helper-text
          type="error"
          error="Please select an option above"
          ?hidden="${!this.employmentActiveMissing}"
          id="employmentActiveInvalid"
        ></fs-helper-text>
      </div>
    `;
  }

  firstUpdated() {
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name: 'activeEmployment',
          isValid: !this.employmentActiveMissing,
        },
      })
    );
  }

  employmentActiveChange(ev) {
    stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
      replacements: {
        value: `${this.coAppPrefix}activeIncomeVerification`,
      },
    });
    this.employmentActiveMissing = false;
    if (ev.target.validity.valid) {
      this.values.activeIncomeVerification = ev.target.value;
    }

    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name: 'activeEmployment',
          isValid: true,
        },
      })
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: { name: 'activeEmployment', isValid: true },
      })
    );
  }
}

customElements.define(
  'refi-personal-employment-active-toggle',
  RefiPersonalEmploymentActiveToggleComponent
);
